import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useTranslation } from '@fluxora/i18n';
import { Alert, Button } from '@fluxora/ui';

import { isResumeRestartState } from '../services/resume-confirm.service';

/**
 * E-CRM04 — the neutral notice on the start page after a phone check ended
 * without restoring anything (three wrong numbers, the 15-minute hold expired,
 * or "Start over instead"). It says only that we could not restore the details —
 * never why, because the person at the keyboard may not be the lead.
 *
 * Carried in router `location.state` by `ResumeConfirmPage`, so a reload or a
 * shared URL never shows it. Dismissible; `role="status"`.
 */
export function ResumeRestartNotice(): JSX.Element | null {
  const { t } = useTranslation();
  const { state } = useLocation();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !isResumeRestartState(state)) return null;

  return (
    <div className="mx-auto w-full max-w-6xl px-4 pt-6" data-testid="resume-restart-notice">
      <Alert variant="info" title={t('shop.resume.restart.title')} role="status">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <span>{t('shop.resume.restart.body')}</span>
          <Button variant="ghost" size="sm" onClick={() => setDismissed(true)}>
            {t('shop.resume.banner.dismiss')}
          </Button>
        </div>
      </Alert>
    </div>
  );
}
